module.exports = __webpack_public_path__ + "media/images/favicon/secondary/android-icon-192x192-bf20e8fa764205fe0333be532c12a82d.png";